import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  templateUrl: './redirect-checkout-loader.component.html',
  styleUrls: ['./redirect-checkout-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RedirectCheckoutLoaderComponent {
  title = "We're loading your cart";
  subtitle = 'Please give us a few seconds.';
}
